(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-video"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // HMP video tile: pause/play toggle + reduced motion
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hmp-video-toggle]');
    if (!button) return;
    const tile = button.closest('.hmp-video-tile');
    const videos = tile ? tile.querySelectorAll('video') : [];
    const shouldPlay = button.getAttribute('aria-pressed') === 'true';
    videos.forEach((video) => (shouldPlay ? video.play() : video.pause()));
    button.setAttribute('aria-pressed', shouldPlay ? 'false' : 'true');
    button.setAttribute('aria-label', shouldPlay ? 'Pause video' : 'Play video');
  });

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.hmp-video-tile').forEach((tile) => {
        tile.querySelectorAll('video').forEach((video) => video.pause());
        const button = tile.querySelector('[data-hmp-video-toggle]');
        if (button) {
          button.setAttribute('aria-pressed', 'true');
          button.setAttribute('aria-label', 'Play video');
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
